import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react"
import { baseUrl } from "constant"
import { ProjectEndpointCont, getProjectDetailByIdUrl } from "./const"
import { RootState } from "store/store"
import { handlingErrorResponse } from "utils/HandlingErrorResponse"
import { getAuthToken } from "utils/getAuthToken"
import { IResponseType, IAddEditProjectType, IPaginationResponseType, IProjectListResponseType, IGetAllProjectRequestType, IGetProjectDetailParamsType, IProjectByIdDetailsResponseType, IDeleteProjectRequestType, IProjectUpdateStatusRequestType } from "../type"

export const ProjectApi = createApi({
    reducerPath: "projectApi",
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['projectTag'],
    endpoints: (builder) => ({
        GetProjectList: builder.mutation<IPaginationResponseType<IProjectListResponseType[]>, IGetAllProjectRequestType>({
            query: project => ({
                url: ProjectEndpointCont.listProjectUrl,
                method: 'POST',
                body: project
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'projectTag', id: 'ListAllProject' }]
        }),
        AddEditProject: builder.mutation<IResponseType<number>, IAddEditProjectType>({
            query: project => ({
                url: ProjectEndpointCont.addEditProjectUrl,
                method: 'POST',
                body: project.projectObj
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'projectTag', id: 'AddEditProject' }]
        }),
        GetProjectIdByDetails: builder.query<IResponseType<IProjectByIdDetailsResponseType>, IGetProjectDetailParamsType>({
            query: (params) => getProjectDetailByIdUrl(params),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'projectTag', id: 'AddEditProject' }]
        }),
        DeleteProject: builder.mutation<IResponseType<boolean>, IDeleteProjectRequestType>({
            query: project => ({
                url: ProjectEndpointCont.deleteProjectUrl,
                method: 'DELETE',
                body: project.projectId
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'projectTag', id: 'ListAllProject' }]
        }),
        UpdateProjectStatus: builder.mutation<IResponseType<boolean>, IProjectUpdateStatusRequestType>({
            query: project => ({
                url: ProjectEndpointCont.deleteProjectUrl,
                method: 'PUT',
                body: project.projectStatus
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'projectTag', id: 'ListAllProject' }]
        }),
    })
})